export const basePath = "/person/personopplysninger";
